import Maple1 from "../Summarecon Bogor/The Maple.webp"
import Maple2 from "../Summarecon Bogor/The Maple.webp"

const Mapleimages =[
    Maple1,Maple2
]

export default Mapleimages;